if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.content = this.querySelector('.product-media-modal__content');
        this.thumbnails = Array.from(this.querySelectorAll('.product-media-modal__thumbnail'));
        this.prevButton = this.querySelector('.product-media-modal__nav--prev');
        this.nextButton = this.querySelector('.product-media-modal__nav--next');
        this.currentIndex = 0;
        this.zoomedImage = null;
        this.zoomRect = null;
        this.swipeStart = null;
        this.panZoom = this.panZoom.bind(this);

        this.querySelectorAll('.product-media-modal__nav, .product-media-modal__thumbnails').forEach((element) => {
          element.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        this.content.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          this.swipeStart = event.isPrimary ? { x: event.clientX, y: event.clientY } : null;
        });

        this.content.addEventListener('pointercancel', () => {
          this.swipeStart = null;
        });

        this.content.addEventListener('pointerup', (event) => {
          if (event.pointerType !== 'mouse') {
            this.handleSwipe(event);
            return;
          }

          const image = event.target.closest('img[data-media-id]');
          if (!image) return;
          event.stopPropagation();
          this.toggleZoom(image, event);
        });

        if (this.prevButton) {
          this.prevButton.addEventListener('click', () => this.setActiveMedia(this.currentIndex - 1));
        }

        if (this.nextButton) {
          this.nextButton.addEventListener('click', () => this.setActiveMedia(this.currentIndex + 1));
        }

        this.thumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => this.setActiveMedia(index));
        });

        this.addEventListener('keyup', (event) => {
          const key = event.code.toUpperCase();
          if (key === 'ARROWRIGHT') this.setActiveMedia(this.currentIndex + 1);
          if (key === 'ARROWLEFT') this.setActiveMedia(this.currentIndex - 1);
        });
      }

      get mediaItems() {
        return Array.from(this.content.children).filter(
          (element) =>
            element.hasAttribute('data-media-id') && !element.classList.contains('product__media-item--variant')
        );
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      handleSwipe(event) {
        const start = this.swipeStart;
        this.swipeStart = null;
        if (!start || !event.isPrimary) return;

        const deltaX = event.clientX - start.x;
        const deltaY = event.clientY - start.y;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

        this.setActiveMedia(deltaX < 0 ? this.currentIndex + 1 : this.currentIndex - 1);
      }

      toggleZoom(image, event) {
        if (this.zoomedImage === image) {
          this.resetZoom();
          return;
        }

        this.resetZoom();
        this.zoomRect = image.getBoundingClientRect();
        this.zoomedImage = image;
        image.classList.add('is-zoomed');
        image.addEventListener('pointermove', this.panZoom);
        this.setZoomOrigin(event);
      }

      resetZoom() {
        if (!this.zoomedImage) return;
        this.zoomedImage.classList.remove('is-zoomed');
        this.zoomedImage.style.removeProperty('transform-origin');
        this.zoomedImage.removeEventListener('pointermove', this.panZoom);
        this.zoomedImage = null;
        this.zoomRect = null;
      }

      panZoom(event) {
        if (event.pointerType === 'mouse') this.setZoomOrigin(event);
      }

      setZoomOrigin(event) {
        if (!this.zoomRect) return;
        const clamp = (value) => Math.min(100, Math.max(0, value));
        const x = clamp(((event.clientX - this.zoomRect.left) / this.zoomRect.width) * 100);
        const y = clamp(((event.clientY - this.zoomRect.top) / this.zoomRect.height) * 100);
        this.zoomedImage.style.transformOrigin = `${x}% ${y}%`;
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const openedMediaId = this.openedBy.getAttribute('data-media-id');
        const index = this.mediaItems.findIndex((element) => element.getAttribute('data-media-id') === openedMediaId);
        this.setActiveMedia(index === -1 ? 0 : index);
      }

      setActiveMedia(index) {
        const items = this.mediaItems;
        if (!items.length) return;

        const nextIndex = (index + items.length) % items.length;
        const activeMedia = items[nextIndex];
        this.resetZoom();
        if (this.currentIndex !== nextIndex) window.pauseAllMedia();
        this.currentIndex = nextIndex;

        items.forEach((element) => element.classList.toggle('active', element === activeMedia));

        this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
          if (thumbnailIndex === nextIndex) {
            thumbnail.setAttribute('aria-current', 'true');
            thumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest' });
          } else {
            thumbnail.removeAttribute('aria-current');
          }
        });

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
